/** "Sep 26, 2026", the house style for dates. */
export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    .format(new Date(iso));
}

/** "Sep 26, 2026, 07:40", in the viewer's own time zone. */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  const time = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' }).format(date);
  return `${formatDate(iso)}, ${time}`;
}
